<template>
  <div class="dataMask">
    <!-- <div class="closeDataMask">
      <a-icon :type="btnStatus === 0 ? 'fullscreen' : 'fullscreen-exit'" @click="getFullCreeen(btnStatus)" />
      <span style="padding: 0 10px;"></span>
      <a-icon type="close" @click="closeDataMask" />
    </div>
    <iframe :src="dataUrl" width="100%"></iframe> -->
  </div>
</template>

<script>
import { LARGEDATA } from '@/http/config'
export default {
  data() {
    return {
      dataUrl: '',
      n: 0,
      btnStatus: 0
    }
  },
  mounted() {
    // this.dataUrl = LARGEDATA + 'data/yunxing/toApiIndex.html'
    window.open(LARGEDATA + 'data/yunxing/toApiIndex.html', '_self')
  },
  methods: {
    // 全屏方法
    getFullCreeen(btnStatus) {
      console.log(btnStatus)
      this.btnStatus = this.btnStatus === 0 ? 1 : 0
      this.n++
      this.n % 2 == 0
        ? this.outFullCreeen(document)
        : this.inFullCreeen(document.documentElement)
    },
    inFullCreeen(element) {
      let el = element
      let rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen
      if (typeof rfs != 'undefined' && rfs) {
        rfs.call(el)
      } else if (typeof window.ActiveXObject != 'undefined') {
        let wscript = new ActiveXObject('WScript.Shell')
        if (wscript != null) {
          wscript.SendKeys('{F11}')
        }
      }
    },
    outFullCreeen(element) {
      let el = element
      let cfs =
        el.cancelFullScreen ||
        el.webkitCancelFullScreen ||
        el.mozCancelFullScreen ||
        el.exitFullScreen
      if (typeof cfs != 'undefined' && cfs) {
        cfs.call(el)
      } else if (typeof window.ActiveXObject != 'undefined') {
        let wscript = new ActiveXObject('WScript.Shell')
        if (wscript != null) {
          wscript.SendKeys('{F11}')
        }
      }
    },
    closeDataMask() {
      if (this.btnStatus === 1) {
        this.getFullCreeen()
      }
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.dataMask {
  width: 100%;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 1000;
}
iframe {
  height: 100vh;
}
.closeDataMask {
  position: fixed;
  color: #fff;
  right: 20px;
  top: 20px;
  font-size: 26px;
  cursor: pointer;
  margin: 0 10px;
}
.open-mask {
  font-size: 24px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/largedata/largemonitor.vue